/** Teacher Adobe Express image generator. An org that disables it also loses Generate with Adobe in Studio image blocks. */
export const ADOBE_IMAGE_GENERATOR_SLUG = 'image-generator';
export const IMAGE_TOOL_IDS = [ADOBE_IMAGE_GENERATOR_SLUG, 'image-generator-s'];

/** Native (non-Adobe) teacher image generator. Distinct from IMAGE_TOOL_IDS so Adobe pages stay on the legacy implementation. */
export const MAGIC_IMAGES_SLUG = 'magic-images';
export const STEM_GRAPHIC_SLUG = 'stem-graphic';

export const RAINA_TOOL_SLUG = 'raina-chat';

/** Teacher custom chatbot. Its instructions are the whole system message: no global preamble. */
export const CUSTOM_CHATBOT_SLUG = 'custom-chatbot';

/** The sampling a `tool_configs` row with blank columns has always run on. */
export const TOOL_CONFIG_DEFAULT_TEMPERATURE = 0.7;
export const TOOL_CONFIG_DEFAULT_TOP_P = 1;
export const CWF_INSIGHTS_CHAT_SLUG = 'cwf-insights-chat';
export const QUIZ_INSIGHTS_CHAT_SLUG = 'quiz-insights-chat';
/** Student-facing "Quiz Me" chatbot. Gets `generateMultipleChoiceOptions` so its multiple-choice options are generated rather than written by the model (PEN-690). */
export const QUIZ_ME_STUDENT_SLUG = 'quiz-me-s';
export const TOOL_RECOMMENDATIONS_SLUG = 'tool-recommendations';
export const TOOL_NOT_FOUND = 'Tool not found';

/**
 * The referral marker on a tool-page link, and the one value Raina's tool suggestion sends.
 *
 * Writer and reader cannot see each other — the suggestion link is built in `features/chat`, the
 * `?ref` is read on the tool page — and a rename on either side would break the discovery funnel
 * with no type error and no failing test, since the assertions sit on the writer's side.
 */
export const REFERRAL_SOURCE_PARAM = 'ref';
export const RAINA_SUGGESTION_REFERRAL = 'raina-suggestion';

export const USER_ROLES_WITH_TOOL_MANAGEMENT = ['org_admin', 'internal', 'superuser'];

export const TOOL_API_OVERRIDES: Partial<Record<string, string>> = {
  [RAINA_TOOL_SLUG]: '/api/generations/raina',
  'quiz-insights-chat': '/api/generations/insights-chat',
  'cwf-insights-chat': '/api/generations/insights-chat',
};
